// extracted by mini-css-extract-plugin
export default {"hideTooltip":"L--z","fadeIn":"M--z","delay":"N--z","recommendedSizeTooltip":"O--z"};